import CategoryIcon from '@material-ui/icons/TurnedIn';
import CategoryList from './CategoryList';
import CategoryCreate from './CategoryCreate';
import CategoryEdit from './CategoryEdit';
const CategoryModule = {
    list: CategoryList,
    icon: CategoryIcon,
    create: CategoryCreate,
    edit: CategoryEdit,
}; export default CategoryModule;